import React from 'react';
import { Input, Button, PaperClip, Select, Textarea, Table, Tooltip } from 'components';
import { QuoteService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { EyeBlackIcon } from 'assets/icons';
import { connect } from 'react-redux';
import moment from 'moment';

interface Props extends RootState {
	onClose?: any;
	item?: any;
}

class ModalView extends React.Component<Props> {

	state = {
		header: [
			'Fecha de recepción',
			'Clínica',
			'Ciudad',
			'Acción'
		]
	}
	
	render() {
		return (
			<div id="modal-view-quote">
				<h3>Cotizaciones recibidas</h3>
				{
					this.props.item?.responses.length > 0 && (
						<Table data={ this.props.item?.responses?.length } header={ this.state.header }>
							{
								this.props.item?.responses?.map((item: any) => {
									return (
										<tr>
											<td>{ moment(item?.created_at).format('DD-MM-YYYY') }</td>
											<td>{ item?.user?.name }</td>
											<td>{ item?.user?.city?.name }</td>
											<td>
												<Tooltip title="Ver">
													<a target="_blank" className="link-icon" href={ Constants.BASE_STORAGE + item?.file }>
														<img src={ EyeBlackIcon } />
													</a>
												</Tooltip>
											</td>
										</tr>
									)
								})
							}
						</Table>
					)
				}
				{
					this.props.item?.responses.length == 0 && (
						<p className="no-items">No se han recibido cotizaciones</p>
					)
				}
				<div className="row row-buttons">
					<div className="col-md-12 text-center">
						<Button type="button" className="btn-close" onClick={ () => this.props.onClose() }>
							Cerrar
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalView);